import { axiosInstanceNotAuthorized } from './axiosInstance';

export const getQuizData = (teamHash, language) =>
    axiosInstanceNotAuthorized.get(`survey?team_hash=${teamHash}&language=${language}`);

export const postQuiz = (quizData) =>
    axiosInstanceNotAuthorized.post(`survey/results/`, quizData, {
        headers: {
            'Content-Type': 'application/json',
        },
    });

// export const postChosenBehaviors = (behaviorsData) => axiosInstance.post(`survey/chosen_behaviors/`, behaviorsData);
